<template>
  <FormModal
    :visible="showModalCreate > 0"
    title="Termos de uso"
    :hide-footer="true"
    width="800px"
    @update:visible="closeModal"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <svg
          class="w-10 h-10 text-blue-600 dark:text-blue-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Termos de uso
        </h2>
      </div>
    </template>

    <div class="space-y-4">
      <!-- Conteúdo dos termos -->
      <div
        class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 max-h-80 overflow-auto bg-gray-50 dark:bg-slate-800"
      >
        <div
          id="conteudoImpressao"
          v-html="conteudoTermosFormatado"
          class="prose prose-sm dark:prose-invert max-w-none text-gray-700 dark:text-gray-300"
        ></div>
      </div>

      <!-- Instruções e mensagens -->
      <div
        v-if="bloquearAceite != true && listaAssinantes.length > 1"
        class="space-y-3"
      >
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <p
              v-if="erroConfirmar"
              class="text-sm text-red-600 dark:text-red-400 mb-2"
            >
              Necessário aceitar os termos para confirmar adesão ao produto
            </p>
            <p class="text-sm text-gray-700 dark:text-gray-300">
              Selecione abaixo os representantes que deverão assinar o
              documento:
            </p>
          </div>
          <button
            @click="abrirModalSaibaMais()"
            class="flex items-center gap-1 text-xs text-primary dark:text-blue-400 hover:text-primary-dark dark:hover:text-blue-300 underline transition-colors"
          >
            <span>instruções</span>
            <img src="@/assets/info.png" class="w-4 h-4" alt="Info" />
          </button>
        </div>
      </div>

      <!-- Seleção de assinantes -->
      <div
        v-if="
          bloquearAceite != true &&
          !habImpressao &&
          (listaAssinantes.length > 1 ||
            this.user.TipoCliente != 'Pessoa Física' ||
            this.existeRepresentante)
        "
        class="space-y-2"
      >
        <div class="relative w-full max-w-md mx-auto">
          <div
            v-if="isOpen"
            class="absolute bottom-full left-0 right-0 mb-1 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg shadow-lg max-h-48 overflow-y-auto z-10"
          >
            <div
              v-for="assinante in listaAssinantes"
              :key="assinante.TipoPessoaGuid"
              class="p-3 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
            >
              <label class="flex items-start gap-2 cursor-pointer">
                <input
                  :id="'assinante_' + assinante.TipoPessoaGuid"
                  type="checkbox"
                  :value="assinante"
                  v-model="selectedOptions"
                  class="mt-1 rounded border-gray-300 dark:border-slate-600 text-primary focus:ring-primary"
                />
                <div class="flex-1 text-sm">
                  <div class="font-medium text-gray-900 dark:text-gray-100">
                    {{ assinante.TipoPessoaDescricao }} - {{ assinante.Nome }}
                  </div>
                  <div class="text-gray-500 dark:text-gray-400 text-xs">
                    {{ assinante.Email }}
                  </div>
                </div>
              </label>
            </div>
          </div>
          <button
            @click="toggleDropdown"
            class="w-full px-4 py-2.5 bg-primary dark:bg-blue-600 text-white rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors flex items-center justify-between"
          >
            <span class="font-medium"
              >{{ selectedOptions.length }} Selecionado(s)</span
            >
            <span class="transition-transform" :class="{ 'rotate-180': isOpen }"
              >▼</span
            >
          </button>
        </div>
      </div>

      <!-- Mensagem representante -->
      <p
        v-if="
          this.user.TipoCliente == 'Pessoa Física' && this.existeRepresentante
        "
        class="text-center text-sm text-gray-600 dark:text-gray-400"
      >
        O assinante é um representante legal.
      </p>

      <!-- Botões de ação -->
      <div
        class="flex flex-col sm:flex-row gap-3 sm:justify-center"
        :class="{ 'justify-center': bloquearAceite }"
      >
        <button
          v-if="bloquearAceite != true"
          @click="confirmar"
          :disabled="requisicaoPendente"
          class="order-1 sm:order-2 px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
        >
          {{
            requisicaoPendente
              ? "Processando..."
              : this.user.TipoCliente == "Pessoa Física" &&
                !this.existeRepresentante
              ? "Confirmar"
              : "Enviar para assinatura"
          }}
        </button>
        <button
          v-if="habImpressao"
          @click="imprimir"
          class="order-1 sm:order-2 px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
        >
          Imprimir
        </button>
        <button
          @click="closeModal"
          class="order-2 sm:order-1 px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
        >
          Voltar
        </button>
      </div>
    </div>

    <!-- Loading overlay -->
    <div
      v-if="requisicaoPendente"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 flex items-center justify-center rounded-lg z-50"
    >
      <div class="spinner"></div>
    </div>
  </FormModal>

  <ModalInformativoSaibaMais
    :conteudo="conteudoSaibaMais"
    :titulo="'Como funciona'"
  />
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/axios";
import FormModal from "@/components/FormModal.vue";
import ModalInformativoSaibaMais from "@/views/Cadastro/SaibaMais/ModalInformativoSaibaMais.vue";

export default {
  components: {
    FormModal,
    ModalInformativoSaibaMais,
  },
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_TERMOS_DOCUMENTOS",
      bloquearAceite: "GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE",
      listaDocumentos: "GET_LISTA_DOCUMENTOS",
      listaDocumentosClientes: "GET_LISTA_DOCUMENTOS_CLIENTE",
      listaAssinantes: "GET_LISTA_ASSINANTES",
      habImpressao: "GET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO",
      user: "auth/user",
    }),
    existeRepresentante() {
      return this.listaAssinantes?.some(
        (x) => x.TipoPessoaDescricao === "Representante",
      );
    },
    conteudoTermosFormatado() {
      // Adiciona target="_blank" a todas as tags <a>
      return this.conteudoTermos.replace(/<a href/g, '<a target="_blank" href');
    },
  },
  data() {
    return {
      aceitoTermos: false,
      erroConfirmar: false,
      conteudoTermos: "",
      requisicaoPendente: false,
      conteudoSaibaMais: `Os responsáveis indicados para assinatura, receberão um e-mail,
com a declaração para que mesmo seja assinado. Portanto, uma declaração só será
considerada como assinada, quando todos os indicados assinarem. <br/><br/>

Cada indicado para assinatura, deverá ler e assinar clicando
no comando de assinar que estará disponível no e-mail, sendo este o aceite
formal da declaração.<br/><br/>

O cadastro só será finalizado, quando todos os campos
obrigatórios forem informados e quando as declarações forem assinadas.`,
      isOpen: false,
      selectedOptions: [], // Armazena as opções selecionadas
      options: [
        { label: "Pessoa Jurídica", value: "PJ" },
        { label: "Pessoa Física", value: "PF" },
        { label: "Fundo de Investimento", value: "FU" },
      ],
    };
  },
  watch: {
    listaAssinantes() {
      if (this.listaAssinantes.length == 1) {
        this.selectedOptions.push(this.listaAssinantes[0]);
      }
    },
    showModalCreate() {
      this.aceitoTermos = this.bloquearAceite;
      if (this.showModalCreate > 0) {
        if (
          this.listaDocumentosClientes != null &&
          this.listaDocumentosClientes.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0] != null
        ) {
          this.conteudoTermos = this.listaDocumentosClientes.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0]?.Texto;
        } else {
          this.conteudoTermos = this.listaDocumentos.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0]?.Texto;
        }
      } else {
        this.conteudoTermos = "";
      }
    },
    listaDocumentosClientes() {
      if (this.showModalCreate > 0) {
        if (
          this.listaDocumentosClientes != null &&
          this.listaDocumentosClientes.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0] != null
        ) {
          this.conteudoTermos = this.listaDocumentosClientes.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0]?.Texto;
        } else {
          this.conteudoTermos = this.listaDocumentos.filter(
            (obj) => obj.TemplateId == this.showModalCreate,
          )[0]?.Texto;
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("FETCH_PJ_LISTA_ASSINANTES");
    this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);
  },
  methods: {
    abrirModalSaibaMais() {
      this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", true);
    },
    imprimir() {
      // Pega o conteúdo da div que você deseja imprimir
      const conteudoImpressao =
        document.getElementById("conteudoImpressao").innerHTML;

      // Cria uma nova janela para impressão
      const janelaImpressao = window.open("", "", "width=600,height=400");

      // Adiciona o conteúdo e o estilo necessário para impressão
      janelaImpressao.document.write(`
        <html>
          <head>
            <title>Termos de Uso</title>
            <style>
              /* Adicione aqui os estilos que deseja aplicar durante a impressão */
              body {
                font-family: Arial, sans-serif;
              }
              div {
                padding-right: 25px;
                padding-left: 25px;
                overflow: hidden scroll;
              }
            </style>
          </head>
          <body>
            <div>${conteudoImpressao}</div>
          </body>
        </html>
      `);

      // Executa o comando de impressão
      janelaImpressao.document.close(); // Fecha o documento para garantir que tudo seja renderizado
      janelaImpressao.focus(); // Garante que a janela esteja em foco
      janelaImpressao.print(); // Inicia a impressão
      janelaImpressao.close(); // Fecha a janela após a impressão
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeModal() {
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
      this.isOpen = false;
      this.erroConfirmar = false;
    },
    async confirmar() {
      console.log("confirmar", this.user.TipoCliente);
      if (
        !this.existeRepresentante &&
        this.user.TipoCliente == "Pessoa Física"
      ) {
        await this.confirmarPF();
        return;
      }

      this.isOpen = false;
      var obj = {
        TemplateId: this.showModalCreate,
        Assinantes: this.selectedOptions,
        Usuario: this.user.NomeRazaoSocial,
      };
      this.requisicaoPendente = true;

      await api
        .post("/declaracao/assinantes", obj)
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$alert({
              icon: "success",
              title: "Assinatura solicitada",
              text: "Documento foi enviado por e-mail para assinatura",
            }).then((result) => {
              this.requisicaoPendente = false;
              if (result.value) {
                this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                this.$store.commit(
                  "SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE",
                  false,
                );
                this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE");
              }
            });
          } else {
            this.requisicaoPendente = false;
            this.$alert({
              icon: "error",
              title: "Oops...",
              text: `Falha ao enviar para assinatura`,
            });
          }
        })
        .catch((error) => {
          this.requisicaoPendente = false;

          this.$alert({
            icon: "error",
            title: "Falha ao vincular assinantes ao documento",
            text: `${
              error.response.data.data[0] != null
                ? error.response.data.data[0]
                : error.response.data.descricao
            }`,
          });
        });
    },
    async getIpAddress() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        return data.ip;
      } catch (error) {
        console.error("Error fetching IP address:", error);
        return null;
      }
    },
    async confirmarPF() {
      var ip = await this.getIpAddress();
      var obj = {
        DeclaracaoId: 0,
        TemplateId: this.showModalCreate,
        UsuarioAssinatura: this.user.NomeRazaoSocial,
        Status: "Assinado",
        DataAssinatura: new Date(),
        IP: ip,
      };
      this.requisicaoPendente = true;

      const retorno = await api.post("/declaracao/cliente", obj);
      if (retorno.status == 200) {
        this.$alert({
          icon: "success",
          title: "Ler os termos",
          text: "Termos aceitos com sucesso",
        }).then((result) => {
          this.requisicaoPendente = false;
          if (result.value) {
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
            this.$store.commit(
              "SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE",
              false,
            );
            this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS");
            this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE");
          }
        });
      } else {
        this.requisicaoPendente = false;
        this.$alert({
          icon: "error",
          title: "Oops...",
          text: `Falha ao aceitar os termos`,
        });
      }
    },
  },
};
</script>

<style lang="scss">
/* Estilos para renderização correta do HTML dos termos */

#conteudoImpressao {
  width: max-content !important;

  /* Garante que listas numeradas apareçam */
  ol {
    list-style-type: decimal !important;
    padding-left: 2rem !important;
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  ol li {
    display: list-item !important;
    margin-bottom: 0rem !important;
    padding-left: 0.5rem !important;
  }

  /* Listas não ordenadas também */
  ul {
    list-style-type: disc !important;
    padding-left: 2rem !important;
  }

  ul li {
    display: list-item !important;
    margin-bottom: 0.5rem !important;
  }

  /* Preserva parágrafos do Word */
  p.MsoNormal {
    margin-bottom: 0.75rem;
    line-height: 1.6;
  }

  /* Remove tags vazias do Office */
  o\:p {
    display: none;
  }

  /* Links */
  a {
    color: #3b82f6;
    text-decoration: underline;
    white-space: nowrap;
  }

  a:hover {
    color: #2563eb;
  }

  /* Garante que itens da lista não criem scroll individual */
  ol li,
  ul li {
    overflow: visible;
  }
}
</style>

<style lang="scss" scoped>
/* Estilos customizados mínimos - a maioria vem do FormModal */
</style>
